module.exports = __webpack_public_path__ + "static/media/SortedNewUp.b00de0ff.svg";